'use client';

import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';
import { Input } from '@pickleballinc/ui/components/ui/input';
import { useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';

export interface IDivisionsPageFilters {
	search: string;
}

const getNewSearchParams = (filters: IDivisionsPageFilters) => {
	const newSearchParams = new URLSearchParams(window.location.search);

	if (filters.search) {
		newSearchParams.set('search', filters.search);
	} else {
		newSearchParams.delete('search');
	}

	return newSearchParams || '';
};

export const FiltersForDivisionsPage = () => {
	const router = useRouter();
	const searchParams = useSearchParams();

	const [filters, setFilters] = useState<IDivisionsPageFilters>({
		search: searchParams?.get('search') ?? ''
	});

	const emptyFilters: IDivisionsPageFilters = {
		search: ''
	};

	const handleReset = () => {
		setFilters(emptyFilters);
		router.replace('?');
	};

	return (
		<div className="flex flex-col md:flex-row  justify-between gap-3 mt-4 lg:mt-6 lg:mb-2">
			<div className={`relative w-full lg:max-w-[414px]`} data-testid="players-search">
				<Input
					type="text"
					placeholder="Search"
					value={filters.search}
					onChange={(e) => setFilters({ ...filters, search: e.target.value })}
					onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => {
						if (event.key === 'Enter') {
							router.replace(`?${getNewSearchParams(filters)?.toString()}`);
							event.currentTarget.blur();
						}
					}}
					className="w-full !rounded-md border border-gray-300 pl-8 focus-visible:ring-0 bg-white h-10"
					maxLength={100}
					data-testid="players-search-field"
				/>
				<FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
			</div>
			<div className="flex flex-row gap-4">
				<Button onClick={() => router.replace(`?${getNewSearchParams(filters)?.toString()}`)} size="lg">
					Apply
				</Button>

				<Button onClick={handleReset} size="lg" variant="outline">
					Reset
				</Button>
			</div>
		</div>
	);
};
